import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { timer } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Router } from '@angular/router';

import { CampaignIncentivesService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import type { TCampaignIncentive, TResponse } from '@shared/models';

@Component({
    'selector': 'app-campaignIncentives',
    'templateUrl': './campaignIncentives.page.html',
    'styleUrls': ['./campaignIncentives.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class CampaignIncentivesPage extends ViewBasePage implements OnInit, OnDestroy {
    public incentives: TCampaignIncentive[] = [];
    // private incentivesSubscription: any;
    private incentivesSubscription: any;    // Observable<TCampaignIncentive[]>;

    constructor( private campaignIncentivesService: CampaignIncentivesService, 
        injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_SETTINGS_CAMPAIGN_INCENTIVES);
    }

    public override ngOnInit(): void {
        const incentivesObservable = this.campaignIncentivesService.getObservable();
        this.incentivesSubscription = incentivesObservable.subscribe((incentives: TCampaignIncentive[]) => {
            this.incentives = [];
            timer(1000);
            this.incentives = this.campaignIncentivesService.sort(incentives);
        });
        this.initMoreMenu();
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tour', 'show-campaign-incentives-tour');
    }

    public override ngOnDestroy(): void {
        this.incentivesSubscription.unsubscribe();
    }

    /*
        // Move the ticket from one position to another.
        public async onIncentiveMove(ev) {
            try {
                // console .log(ev);
                await this.uxHelperService.showSpinner();
                const fromIndex = ev.detail.from;
                const toIndex = ev.detail.to;
    
                await this.swapAndSaveIncentivePositions(fromIndex, toIndex);
    
                ev.detail.complete();
            } catch (err) {
                await this.uxHelperService.hideSpinner();
                this.uxHelperService.showAlert('Error', err.message);
            } finally {
                await this.uxHelperService.hideSpinner();
            }
        }
    
        // Swap and save the new incentive positions.
        private async swapAndSaveIncentivePositions(fromIndex: number, toIndex: number) {
            try {
                const fromIncentive = this.incentives[fromIndex];
    
                // Move the incentives to their new array positions
                this.incentives.splice(fromIndex, 1);
                this.incentives.splice(toIndex, 0, fromIncentive);
                
                // Update the sequence numbers.
                let promises = [];
                this.incentives.forEach((incentive, index) => {
                    if (incentive.sequenceNumber !== index + 1) {
                        incentive.sequenceNumber = index + 1;
                        const promise = this.campaignIncentivesService.update(incentive);
                        promises.push(promise);
                    }
                });
                await Promise.all(promises);    
            } catch (err) {
                throw err;
            }
        }
    */

    public onCampaignIncentiveClick(): void {
        this.router.navigateByUrl('/marketing/campaignIncentive');
    }
    
    public async confirmDeleteIncentive(incentive: TCampaignIncentive) {
        const question = 'Are you sure you want to delete incentive: ' + incentive.title + '?';
        const response = await this.uxHelperService.showAlert('Confirm Delete', question);
        if (response.okay) {
            this.deleteIncentive(incentive);
        }
    }

    private async deleteIncentive(incentive) {
        try {
            await this.uxHelperService.showSpinner('Deleting.');
            await this.campaignIncentivesService.delete(incentive.uid);
            this.uxHelperService.showToast('Incentive has been deleted.');
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }

    public onIncentiveClick(incentiveUid: string): void {
        this.router.navigateByUrl(`/marketing/campaignIncentive/${incentiveUid}`);
    }
}
